import React from 'react';
import { IoArrowForward } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const CreativeStudio = () => {
  const navigate = useNavigate();
  return (
    <section className="py-4 md:py-16 px-2 md:px-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-2 md:mb-12 flex justify-center md:justify-start w-full">
        <h2 className="text-2xl lg:text-4xl font-bold text-gray-900">Our Creative studio</h2>
      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-8 items-center">
        {/* Images Container */}
        <div className="flex gap-2  md:gap-3">
          {/* First Image - Smaller width */}
          <div className="md:w-[42%] w-1/2 h-full md:h-96 overflow-hidden h-96">
            <img 
              src="/studio/photo1.webp" 
              alt="Blue hoodie product photography"
              className="w-full h-[250px] md:h-full object-cover"
            />
          </div>

          {/* Second Image - Larger width */}
          <div className="md:w-[58%] w-1/2  h-full md:h-96 overflow-hidden h-96">
            <img 
              src="/studio/photo2.webp" 
              alt="Photography studio setup"
              className="w-full h-[250px] md:h-full object-cover"
            />
          </div>
        </div>

        {/* Text Content Container */}
        <div className="bg-soft-gray md:h-96 p-8 flex flex-col justify-between">
          <p className="text-base font-normal md:text-lg leading-relaxed">
            We create high-quality product photography that highlights every detail with precision and care. 
            Through thoughtful lighting, composition, and styling, we craft images that not only showcase your products 
            but elevate your brand identity.
          </p>

          <div className="flex justify-center md:justify-end max-md:mb-6 max-md:mt-2">
            <button 
            onClick={() => navigate('/studio')}
              className="text-white md:px-6 px-4 py-2 md:py-3 text-sm  md:text-base rounded-full flex items-center gap-3 font-semibold hover:opacity-90 transition-opacity"
              style={{ 
                backgroundColor: 'var(--primary-blue)',
                boxShadow: '0 8px 20px rgba(29, 68, 233, 0.3)'
              }}
            >
              Check our work
              <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center">
                <IoArrowForward className="text-black text-sm" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreativeStudio;